/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import DetailsList from "../../components/Listing/DetailsList";
import DownloadList from "../../components/Listing/DownloadList";
import { Advantages } from "../../components/CartaoAssociado/Advantages";
import { CardSection } from "../../components/CartaoAssociado/CardSection";
import { Loading } from "../../components/Loading/Loading";
import NotificationBanner from "../../components/Notifications/NotificationBanner";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import React, { Component } from "react";
import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import "./CartaoAssociado.css";

var reactPlugin = new ReactPlugin();

export class CartaoAssociado extends Component {
  static displayName = CartaoAssociado.name;

  constructor(props) {
    super(props);
    this.state = {
      savedValue: [],
      error: [],
      associateCard: [],
      loading: true,
    };
  }

  async componentDidMount() {
    //console.log("CA Context ", this.context);

    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.getData();
    }
  }

  renderCard(savedValue, associateCard) {
    return (
      <div className="main">
        <NotificationBanner />
        {/*Title*/}
        <div className="title-bar">
          <div className="title mobile-associate-title">Cartão de Associado</div>
        </div>
        {/*Main card*/}
        <div className="associate-div">
          <CardSection benefitsValue={savedValue.benefitValue} />
          <Advantages data={associateCard} />
          <section className="information-section">
            <DetailsList list={associateCard.benefits} />
          </section>
          {/*Downloads Section*/}
          <section className="downloads-section">
            <div className="row">
              <DownloadList files={associateCard.documents} />
            </div>
          </section>
        </div>
      </div>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <Loading />
    ) : this.state.error ? (
      <ErrorPage />
    ) : (
      this.renderCard(this.state.savedValue, this.state.associateCard)
    );
    return <React.Fragment>{contents}</React.Fragment>;
  }

  async getData() {
    try {
        const { selectedUserID, idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
            clientId: selectedUserID,
        };

        // chamadas paralelas
        const [resBenefits, resAssociate] = await Promise.all([
            fetch("/Benefits/GetSavedValue", { headers }),
            fetch("/Benefits/GetAssociateCard", { headers }),
        ]);

        if (!resBenefits.ok || !resAssociate.ok) {
            throw new Error(
                `Erro HTTP: benefits=${resBenefits.status}, associate=${resAssociate.status}`
            );
        }

        const [benefits, associateData] = await Promise.all([
            resBenefits.json(),
            resAssociate.json(),
        ]);

        this.setState({
            savedValue: benefits,
            associateCard: associateData,
            error: false,
            loading: false,
        });

    } catch (error) {
        console.error("Error in getData:", error);

        this.setState({
            error: true,
            loading: false,
        });

        sendLogError(error.message, "getData");
    }
  }  
}

CartaoAssociado.contextType = ContextConstructor;

export default withAITracking(reactPlugin, CartaoAssociado);
